<div class="page-heading" [ngClass]="{ 'page-heading__flex': flexHeader }">
  <h1 class="page-heading__title">{{ pageTitle }}</h1>
  <div class="page-heading__description">
    <ng-content select="[subheading]">{{ pageDescription }}</ng-content>
  </div>
  <div class="page-heading__btns">
    <ng-content></ng-content>
  </div>
</div>
